export default __webpack_public_path__ + "static/media/AR.40a9330d.svg";